import CommonLayout from 'components/CommonLayout';
import Body from 'containers/LexiquePage/Body';
import messages from 'containers/LexiquePage/messages';
import React from 'react';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';

const LexiquePage = () => {
  return (
    <GaLoadHOC category={EVENT_CATEGORIES.LEXIQUE} label="Lexique">
      <CommonLayout title={messages.title_lexique} content={<Body />} />
    </GaLoadHOC>
  );
};

export default LexiquePage;
